import { useCallback, useEffect } from 'react';
import { useUpdateAttendee } from 'circulator/hooks/attendee/useUpdateAttendee';
import usePreauthorizedUsersStore from 'circulator/hooks/usePreauthorizedUsersStore';
import { AttendeeStatus } from 'common/types';
import type { Attendee } from 'common/types/circulator';

interface Props {
    procedureId: number;
    companyId?: number;
    attendee: Attendee;
}

export const AutoJoin = ({ procedureId, companyId, attendee }: Props) => {
    const { updateAttendee } = useUpdateAttendee(procedureId, attendee.id);
    const acceptedRoles = usePreauthorizedUsersStore(state => state.acceptedRoles);

    const handleAcceptRequest = useCallback(async () => {
        await updateAttendee({ status: AttendeeStatus.ACCEPTED });
    }, [updateAttendee]);

    useEffect(() => {
        if (attendee.status === AttendeeStatus.REQUESTED) {
            console.log('Attendee status is REQUESTED');
            if (companyId && acceptedRoles.includes('PARTNER') && attendee.companyIds.includes(companyId)) {
                console.log('Attendee is a company user');
                handleAcceptRequest();
                return;
            }

            if (attendee.roles.some(x => acceptedRoles.filter(x => x !== 'PARTNER').includes(x))) {
                console.log('Attendee is a preauthorized user', attendee.roles, acceptedRoles);
                handleAcceptRequest();
            } else {
                console.log('Attendee is not a preauthorized user');
            }
        }
    }, [acceptedRoles, attendee, companyId, handleAcceptRequest]);

    return <></>;
};
